import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useToast, useModal, usePage } from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LBL_LANG } from "./services/OsciLblLangPrcssService";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Label processing Modify
 * !==  라벨 처리 수정 ==!
 */

export const OSCI0111006S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { lblId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        lblLang: useForm({
            defaultSchema: SF_LBL_LANG,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Label Information !== 라벨 정보 조회==!
        getLblLang: useFetch({
            api: (data) => APIS.getLblLang(lblId),
            enabled: !!lblId,
            onSuccess: (data) => {
                const lblLang = data.lblLang.content;
                const lblLangInfoList = lblLang.lblLangInfoList;

                if (lblLangInfoList) {
                    lblLangInfoList.map((item: any) => {
                        switch (item.langCd) {
                            case "EN":
                                lblLang.lblNmEn = item.lblNm;
                                break;
                            case "TZ":
                                lblLang.lblNmTz = item.lblNm;
                                break;
                            default:
                                lblLang.lblNmKo = item.lblNm;
                                break;
                        }
                    });
                }
                form.lblLang.setValues(lblLang);
            },
            onError: (error) => {},
            showToast: true,
        }),
        deleteLblLang: useFetch({
            api: (lblIds) => APIS.deleteLblLang(lblIds),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onCancel: () => {
                        navigate(URLS.osci0111004q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
        // Save Label Information !== 라벨 정보 저장 ==!
        saveLblLang: useFetch({
            api: (lblIds) => APIS.updateLblLang(lblIds),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onCancel: () => {
                        navigate(`${URLS.osci0111004q}`);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // delete Label Information !== 라벨 정보 삭제 ==!
        deleteLblLang: () => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteLblLang.fetch(lblId);
                },
            });
        },
        // Save Label Information !== 라벨 정보 저장 ==!
        saveLblLang: form.lblLang.handleSubmit(
            () => {
                const data = form.lblLang.getValues();
                console.log(data);
                modal.openModal({
                    content: "msg.osc.00090",
                    onConfirm: () => {
                        fetch.saveLblLang.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getLblLang.fetch();
        form.lblLang.setSchema("lblId", { edit: false });
        form.lblLang.setSchema("lblTpCd", { edit: false });
        // Service Category 는 고정값이므로 수정할 수 없도록 한다.
        form.lblLang.setEditable("bsopClsfCd", false);
    }, []);

    return (
        <Page>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblId}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblTpCd}></Group.Control>
                                <Group.Control {...form.lblLang.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmEn}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmTz}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.lblLang.schema.lblNmKo}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0111004q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.saveLblLang();
                        }}
                    ></Button>
                    <Button
                        role="delete"
                        onClick={() => {
                            handler.deleteLblLang();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
